import styled, { css } from 'styled-components';
import StepsBase, { Step as CustomStep } from 'rc-steps';
import { transparentize } from 'polished';
import { pulse } from 'styles/animation';
import { Form as FormBase } from '@unform/web';
interface StepProps {
  id: string;
  next: string;
  status: string;
}

interface FormGroupsProps {
  $columns: string;
}

interface DadosProps {
  $disabled: boolean;
}
export const StoreContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  margin: 0;

  > div {
    > button {
      align-self: flex-end;
      margin-top: 10px;
      padding: 0 15px 0 15px;
      width: 150px;
    }
  }
  .ButtonGroup {
    display: flex;
    justify-content: space-between;
    margin: 0 1rem;
  }
  header {
    align-items: baseline;
    > button {
      margin-right: 10px;
    }
  }
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 0 15px 0 15px;
  justify-content: space-between;
  section {
    white-space: nowrap;
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 0.5px solid ${props => props.theme.fontColor};
    &:first-of-type {
      margin: 0px 0 15px 0;
    }
  }
`;

export const FormGroups = styled.div<FormGroupsProps>`
  grid-template-columns: ${props => props.$columns};
  display: grid;
  > div {
    &:not(:first-of-type) {
      margin-left: 5px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
`;

export const Lista = styled.ul`
  caret-color: transparent;
`;

export const Item = styled.li`
  display: flex;
  flex-direction: row;
  padding: 15px 0 5px;

  border-bottom: 1px solid
    ${props => transparentize(0.6, props.theme.fontColor)};
  &:last-of-type {
    border-bottom: none;
  }
`;

export const Dados = styled.div<DadosProps>`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  span {
    padding: 3px 0px;
    display: flex;
    font-size: 0.975rem;
    align-items: center;

    p {
      &:first-of-type {
        width: 120px;
      }
      font-size: 0.975rem;
      margin-right: 5px;
      font-weight: 400;
      text-decoration: ${props => (props.$disabled ? 'line-through' : 'none')};
      color: ${props =>
        props.$disabled
          ? props.theme.secondaryFontColor
          : props.theme.fontColor} !important;
    }
  }
`;

export const Steps = styled(StepsBase)`
  display: flex;
  flex: 1.5 1.5;
  width: auto !important;
  align-items: center;
`;

export const Step = styled(CustomStep)<StepProps>`
  .rc-steps-item-title {
    color: ${props => props.theme.fontColor} !important;
    font-weight: 400 !important;
  }
  .rc-steps-item-container {
    margin-left: -2px !important;
  }
  .rc-steps-item-icon {
    span {
      font-size: 28px !important;
      svg {
        stroke-width:${props =>
          props.theme.name === 'light'
            ? '2.3px !important;'
            : '1.3px !important;'};
        size: 30px !important;

      }
    }
  }

  .rc-steps-item-tail {
    &:after {
      height: 3px !important;
      border-radius: 10px !important;
    }
  }

  ${props =>
    props.status === 'finish' &&
    !props.disabled &&
    css`
      .rc-steps-icon {
        color: ${props => props.theme.button.success.out} !important;
      }
      .rc-steps-item-tail {
        ${props.next === 'wait' &&
          css`
            &:after {
              background: linear-gradient(
                90deg,
                ${props => props.theme.button.success.out} 30%,
                ${props => props.theme.button.primary.in} 100%
              );
            }
          `}
        &:after {
          background-color: ${props =>
            props.theme.button.success.out} !important;
        }

        ${props.next === 'error' &&
          css`
            &:after {
              background: linear-gradient(
                90deg,
                ${props => props.theme.button.success.out} 30%,
                ${props => props.theme.button.danger.in} 100%
              );
            }
          `}
        &:after {
          background-color: ${props =>
            props.theme.button.success.out} !important;
        }
      }
    `}

  ${props =>
    props.status === 'process' &&
    !props.disabled &&
    css`
      .rc-steps-item-tail {
        &:after {
          background: linear-gradient(
            90deg,
            ${props => props.theme.button.primary.in} 10%,
            ${props => props.theme.loadingTableColor} 50%
          );
        }
      }
    `}

    ${props =>
      props.status === 'error' &&
      css`
        .rc-steps-item-tail {
          &:after {
            background: linear-gradient(
              90deg,
              ${props => props.theme.button.danger.in} 10%,
              ${props => props.theme.loadingTableColor} 50%
            );
          }
        }
      `}


    ${props =>
      (props.status === 'wait' || props.disabled) &&
      css`
        .rc-steps-icon {
          color: ${props => props.theme.loadingTableColor} !important;
        }
        .rc-steps-item-tail {
          &:after {
            background-color: ${props =>
              props.theme.loadingTableColor} !important;
          }
        }
      `}
      
  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const Alert = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    font-size: 28px;
    fill: ${props => props.theme.warn};
    z-index: 2;
  }
  position: relative;

  transform-origin: 50% 50%;
  animation-duration: 1.7s;
  animation-name: ${pulse};
  animation-iteration-count: 3;
`;

export const Acoes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    opacity: 0.8;
  }
`;

export const AvaliacaoModal = styled.div`
  div {
    &:last-of-type {
      justify-content: center;
      display: flex;
      gap: 1rem;
    }
  }
`;

export const ObservacoesModal = styled.div`
  section {
    margin-bottom: 2rem;
    h4 {
      display: flex;
      width: 100%;
      border-bottom: 0.5px solid ${props => props.theme.fontColor};
      margin-bottom: 0.5rem;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid rgb(116, 117, 117);
    }
    footer {
      text-align: end;
      margin-top: 1rem;
      color: ${props => props.theme.fontColor};
    }
  }
`;
